// export const FEATURED_TAKE_OFF_SITE =
//     {
//         id: 26,
//         name: 'D01',
//         slug: 'd01',
//         image: 'nis.jpeg',
//         featuredLogo: 'EuChamp'
//     }
    export const FEATURED_TAKE_OFF_SITE = null

// Main sites displayed on homepage and in search by default
export const TAKE_OFF_SITES = [
    {
        id: 16,
        name: 'Vršac-Kula',
        historySince: '2019-09', // first month with Flumen readings (probed 2026-09-06)
        slug: 'vrsac-kula',
        image: 'vrsac.webp',
        suitableWindDirections: ['NNW', 'NW'] // FALLBACK only — Flumen Green/Yellow sectors take precedence (StationSectorsContext)
    },
    {
        id: 14,
        name:'Zlatibor-Vojska',
        historySince: '2019-06', // first month with Flumen readings (probed 2026-09-06)
        slug: 'zlatibor-vojska',
        image:'zlatibor.webp',
    },
    {
        id: 24,
        name:'Stolovi',
        historySince: '2023-05', // first month with Flumen readings (probed 2026-09-06)
        slug: 'stolovi',
        image:'stolovi.webp',
    },
    {
        id: 25,
        name:'Rajac',
        historySince: '2023-05', // first month with Flumen readings (probed 2026-09-06)
        slug: 'rajac',
        image:'rajac.webp',
    },
    {
        id: 26,
        name: 'Oreovac - Niš',
        slug: 'oreovac-nis',
        image: 'nis.webp',
    },
    {
        id: 30,
        name: 'Sportski aerodrom Veliki Radinci',
        slug: 'lysm',
        image: 'lysm.webp',
    },
    {
        id: 27,
        name: 'Šajkaš - Titelski breg',
        historySince: '2024-01', // first month with Flumen readings (probed 2026-09-06)
        slug: 'titelski-breg',
        image: 'titleski-breg.webp',
    },
    {
        id: 33,
        name: 'Fruška gora',
        historySince: '2023-04', // first month with Flumen readings (probed 2026-09-06)
        slug: 'fruska-gora',
        image: 'sakotinac.webp',
    },
    {
        id: 29,
        name:'Drvar-Kruškovac',
        historySince: '2023-07', // first month with Flumen readings (probed 2026-09-06)
        slug: 'drvar-kruskovac',
        image:'drvar-kruskovac.webp',
        suitableWindDirections: ['S', 'SW', 'SSW']
    }
]

// Shadow sites - only shown in search when explicitly searched for
export const SHADOW_SITES = [
    // Example shadow site - add your shadow sites here
    {
        id: 42,
        name: 'Gomila - Cazin',
        historySince: '2024-03', // first month with Flumen readings (probed 2026-09-06)
        slug: 'gomila',
        image: 'default.webp',
        suitableWindDirections: ['N', 'NE', 'NW'],
        shadow: true
    }
]

// Combined list of all sites (main + shadow)
export const ALL_SITES = [...TAKE_OFF_SITES, ...SHADOW_SITES]
